import React from 'react';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import ErrorBoundary from './ErrorBoundary';
import db from './db';
var functions = require("./functions.js");

// FactoryDevices component
export default class FactoryDevices extends React.Component {

    loadingHosts=[{id:"1",ip:"",mac:'',hostname:'press "Refresh" to load',"vendor":"",displayAlways:true}];
     // Constructor 
     constructor(props) {
        super(props);
        this.state= {
            hosts:this.loadingHosts,
            displayHosts:this.loadingHosts,
            vendorFilter:"WAVE"
        };
    }
    filterVendor(inVendorFilter){
        if(inVendorFilter===undefined){
            inVendorFilter=this.state.vendorFilter
        } else {
            this.setState({vendorFilter:inVendorFilter});
        }
        let displayHosts=[];
        this.state.hosts.forEach(host=>{
            try{
                if(host.vendor && host.vendor.indexOf(inVendorFilter)>-1){
                    displayHosts.push(host);
                } else if(host.displayAlways){
                    displayHosts.push(host);
                } else if(inVendorFilter===""){
                    displayHosts.push(host);
                }
            } catch (ex){
                displayHosts.push(host);
            }

        })
        this.setState({
            displayHosts : displayHosts
        })

    }
    componentDidMount() {
            //this.queryFactoryHosts();  // wait to query hub
    }
    queryFactoryHosts(){
        this.setState({
            hosts:this.loadingHosts,
            displayHosts:this.loadingHosts
        })
        db.getFactoryHosts( 
            this.props.securityObject
            ,(obj) => { 
                this.setState({
                    hosts : obj.hosts
                })
                this.filterVendor();
            }
        )
    }
    render(){

        // create a button for each button
        let filterButtons=["All","WAVE"];
        this.state.hosts.forEach(host=>{
            if(filterButtons.indexOf(host.vendor)===-1 && host.vendor!==""){
                filterButtons.push(host.vendor)
            }
        })
        let buttonsArray=[];
        let i=100;
        filterButtons.forEach(title=>{
            let filterValue=title;
            if(filterValue==="All"){
                filterValue="";
            }
            let buttonColor="black";
            if(this.state.vendorFilter===filterValue){
                buttonColor="blue";
            }
            var btn = React.createElement("button"
                ,{ id:`btn-${title}-${i++}`
                    ,onClick:this.filterVendor.bind(this,filterValue)
                    ,style:{color:buttonColor}
                }
                ,[title]);
            buttonsArray.push(btn);
        })

        try {
            let height ="85vh";
            if(this.props.height){
                height=this.props.height;
            }

            return(true) ? (
                <div>
                    <h5>
                        <button onClick={()=>this.queryFactoryHosts()} >Refresh</button>
                    </h5>
                    { buttonsArray }
                    <TableScrollbar height={height}>
                        <ErrorBoundary>
                        <Table columns={[
                                    { title:'IP', key: 'ip', width :15}
                                    //,{ title:'copy', key: 'copy', width :5, render:this.renderCopyIpToClipBoard.bind(this)}
                                    ,{ title:'Hostname', key: 'hostname', width :15 }
                                    ,{ title:'MAC address', key: 'mac', width :15 }
                                    ,{ title:'Vendor', key: 'vendor', width :15 }
                                    //,{ title:'Pool Name', key: 'pool_name', width :15 }
                                    //,{ title:'suggestHostname', key: 'suggestHostname', width :15 }
                                    //, { key: 'ssh', title:"ssh", width :5, render:this.renderSSHButton.bind(this)}
                                    //, { key: 'link80', title:"80", width :5, render:this.render80Button.bind(this)}
                                    //, { key: 'link3000', title:"3000", width :5, render:this.render3000Button.bind(this)}
                                    , { key: 'id', title:'buttons', width:40, render:this.renderAllButtons.bind(this) }
                                ]

                                } 
                                dataSource={this.state.displayHosts}
                                onRowClick={this.rowClick.bind(this)}
                        >
                        </Table>
                        </ErrorBoundary>
                    </TableScrollbar>
                    Notes:{this.props.note} access to &nbsp;<button className="" title="command to connect to factorypi from AWS Bastion Host Gateway will be put into clipboard" onClick={() => functions.openWindow( functions.getSSHUrlForGateway("factorypi.hubs.wavedds.com") ) }>AWS<span className="mobileHide"> factorypi via Bastion Host Gateway</span><img alt='copy' height="15px" src="icons8-clone-figure-32.png"></img></button> is required for this to work 
                    <br />
                    vendor name is based on query "select * from v_mac_to_system_type"
                </div>
            ):"";
        } catch (e){
            console.log(e);
            return "";
        }
    }
    /*
    renderSSHButton(cellData, rowData, rowIndex){
        return this.renderButton("ssh", rowData, rowIndex);
    }
    render80Button(cellData, rowData, rowIndex){
        return this.renderButton("80", rowData, rowIndex);
    }
    render3000Button(cellData, rowData, rowIndex){
        return this.renderButton("3000", rowData, rowIndex);
    }*/
    renderButton(action, title, classname, rowData, rowIndex, clipBoard ){
        if(!classname){classname="button";}
        var btn = React.createElement("button"
                            ,{ id:`btn-${title}-${rowIndex}`
                                ,onClick:this.clickButton.bind(this,action,rowData, clipBoard)
                                ,className:classname
                            }
                            ,[title]);
        return btn;    
    }
    renderAllButtons(cellData, rowData, rowIndex){
        let arr=[];
        if(!rowData.displayAlways){
            arr.push(this.renderButton("ssh", "ssh", "", rowData, rowIndex));
            arr.push(this.renderButton("80" , "80" , "", rowData, rowIndex));
            arr.push(this.renderButton("ssh", "dps", "blue-button", rowData, rowIndex, "/usr/bin/python3 /home/pi/wave-v2/wave-led/wave-led.py button_blue"));
            arr.push(this.renderButton("ssh", "dps", "green-button", rowData, rowIndex,"/usr/bin/python3 /home/pi/wave-v2/wave-led/wave-led.py button_green"));
            // pi4
            // /usr/bin/python3 /home/pi/wave-v2/wave-led/wave-led.py button_blue
            // /usr/bin/python3 /home/pi/wave-v2/wave-led/wave-led.py button_green
            // lea
            // 
            
            arr.push(this.renderButton("3000","3000", "", rowData, rowIndex));
            arr.push(this.renderCopyIpToClipBoard("IP", rowData, rowIndex ));

            if(this.props.buttonClick && this.props.buttonClick.length>0){
                arr.push(this.renderNewLine())
                let i=0;
                this.props.buttonClick.forEach( click=>{
                    arr.push(this.renderPropsButton(this.props.buttonTitle[i], click, rowData, rowIndex ));
                    i++;
                });
            }

            var btns = React.createElement("div"
                                ,{}
                                ,arr);
        }
        return btns;          
    }    
    renderCopyIpToClipBoard(title, rowData, rowIndex ){
        var btn = React.createElement("button"
                            ,{ id:`btn-copy-${rowIndex}`
                                ,onClick:this.copyToClipBoard.bind(this,title,rowData)
                                //, img:"icons8-clone-figure-32.png"
                            }
                            ,'IP clip');
        return btn;    
    }
    renderNewLine(){
        var btn = React.createElement("br"
                            ,{ });
        return btn;    
    }    
    renderPropsButton(title, click, rowData, rowIndex ){
        var btn = React.createElement("button"
                            ,{ id:`btn-props-${rowIndex}`
                                ,onClick:click.bind(this,title,rowData)
                            }
                            ,title);
        return btn;    
    }
    clickButton(title,rowData,clipBoard,event){
        if(clipBoard){
            functions.copyToClipBoard(clipBoard);
        }
        if(title==="ssh"){
            functions.openWindow( this.getSSHUrl(rowData.ip) );
        } else {
            functions.openWindow( `http://${rowData.ip}:${title}`);
        }
        ;
    }
    getSSHUrl(host){
           return "ssh://pi@" + host ;
    }
    copyToClipBoard(title,rowData){
        functions.copyToClipBoard(rowData.ip);
    }
    rowClick(rowData){
        if(this.props.onRowClick){
            this.props.onRowClick(rowData);
        }
    }
}
